/**
 * @changelog
 *
 * 2026-09-24 (0.1.0) (jhoward)
 *   - Add OfferCopyCategory and OFFER_COPY_CATEGORY_LABELS, mirroring App\Enums\OfferCopyCategory, and
 *     getOfferCategoryLabel().
 *
 * 2026-09-24 (0.2.0) (jhoward)
 *   - Add "COMP CREDI" and "FREE PLAY" to OfferCopyCategory and OFFER_COPY_CATEGORY_LABELS.
 */

/**
 * The standard offer copy categories.
 *
 * Hand-mirrored from App\Enums\OfferCopyCategory, which mirrors the admin's own -- the source of truth. There is no
 * PHP to TypeScript enum generation in this project.
 */
export type OfferCopyCategory =
  | 'GAMING'
  | 'HOTEL'
  | 'ENT'
  | 'CONCERTS'
  | 'EVENT'
  | 'TOURN'
  | 'BJTOURN'
  | 'INFO'
  | 'VIP EVENTS'
  | 'COMP CREDI'
  | 'FREE PLAY';

/**
 * What a guest sees for each category, as App\Enums\OfferCopyCategory::label() gives it.
 */
export const OFFER_COPY_CATEGORY_LABELS: Record<OfferCopyCategory, string> = {
  GAMING: 'Gaming',
  HOTEL: 'Hotel',
  ENT: 'Entertainment',
  CONCERTS: 'Concerts',
  EVENT: 'Special Events',
  TOURN: 'Tournament',
  BJTOURN: 'Blackjack Tournament',
  INFO: 'Informational',
  'VIP EVENTS': 'VIP Events',
  'COMP CREDI': 'Comp Credit',
  'FREE PLAY': 'Free Play',
};

/**
 * The label for whatever OFFER_COPY_CATEGORY holds.
 *
 * A category outside the standard ones -- an Engage type the admin has not put right yet, such as FREE PLAY -- is shown
 * as it is stored rather than hidden, and an offer with none is 'Uncategorized'.
 */
export function getOfferCategoryLabel(category: string | null | undefined): string {
  const trimmed = (category || '').trim();

  if ('' === trimmed) {
    return 'Uncategorized';
  }

  return OFFER_COPY_CATEGORY_LABELS[trimmed as OfferCopyCategory] || trimmed;
}
